module.exports = __webpack_public_path__ + "img/icon_warning.d6e2b531.svg";